module.exports = "input[type=\"radio\"] {\r\n    display: none;\r\n}\r\n\r\n.hoverable {\r\n    cursor: pointer;\r\n}\r\n"